import { queryKeys } from "@/constants/queryKeyFactory";
import { useQuery } from "@/hooks/api";
import { ApiResponse, QueryOptions } from "@/interfaces/api.interface";
import { IRequestLogs } from "@/interfaces/request.interface";

import { reqSvc } from "@/services/request.service";

export function useLogsByArea(
  areaId: string | null,
  options: QueryOptions = {}
) {
  return useQuery<ApiResponse<IRequestLogs[]>>(
    queryKeys.logs.detail(areaId || ""),
    () => reqSvc.fetchLogsByArea(areaId!),
    {
      ...options,
      enabled: !!areaId,
    }
  );
}
